(() => {
  // Keep cart-page remove links as a normal navigation; the theme's drawer handler
  // otherwise opens an empty drawer while leaving the old cart row on screen.
  document.addEventListener('click', event => {
    if (!document.body.classList.contains('snz24-cart')) return;
    const link = event.target.closest('a[href*="/cart/change"]');
    if (!link) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);
  const activate = (group, tab, moveFocus = false) => {
    const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
    tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (moveFocus) tab.focus();
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-s24-tabs] [role="tab"]');
    if (tab) activate(tab.closest('[data-s24-tabs]'), tab);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-s24-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const group = tab.closest('[data-s24-tabs]');
    const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activate(group, tabs[next], true);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.s24 a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    history.replaceState(null,'', '#' + id);
  });
})();
